import { Box, Button, FormHelperText } from "@material-ui/core";
import Textbox, { Option } from "components/textbox/Textbox";
import PropTypes from 'prop-types';
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../components/dialog/Modal";
import DropdownSelect from "../../components/dropdown-select/DropdownSelect";
import FileDrop from "../../components/file-drop/FileDrop";
import styles from "./FileDropModal.module.scss";

interface Props {
    fileType?: string,
    handleDone: Function,
    handleCancel: Function,
    title: string,
    open: boolean,
    multiple?: boolean,
    message: string,
    enforceTypes?: { key: string, value: string }[]
    enforceTypesMessage?: string
    hasTags?: boolean
}

function FileDropModal(props: Props) {

    const [t, i18n] = useTranslation()

    const [file, setFile] = useState<File[] | null>(null)
    const [fileType, setFileType] = useState<string | null | undefined>(props.fileType || null)
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [tags, setTags] = useState<string[]>([])
    const [pastTags, setPastTags] = useState<Option[]>([])

    function handleDrop(file: File[]) {
        if (file != null) {
            setFile(file)
        }
    }

    function handleDone() {
        if (file != null) {

            if (file.length == 0) {
                setErrorMessage(t('file-drop.please-add-files-before-submiting'))
                return
            }

            if (props.enforceTypes != null && props.enforceTypes.length >= 0 && fileType == null) {
                setErrorMessage(t('file-drop.please-select-a-file-type'))
                return
            }

            file.forEach(file => {
                if (file == null) {
                    setErrorMessage(t('file-drop.bad-file-data-try-again'))
                    return
                }
            });

            props.handleDone(file, fileType, tags)

            setFile(null)
            // setFileType(props.fileType)
            setErrorMessage(null)
            setPastTags(tags.map(tag => ({title: tag, inputValue: tag})))
            setTags([])
        } else {
            setErrorMessage(t('file-drop.please-add-files-before-submiting'))
        }
    }

    function handleCancel() {
        setFile(null)
        setFileType(props.fileType)
        setErrorMessage(null)
        setPastTags(tags.map(tag => ({title: tag, inputValue: tag})))
        setTags([])
        props.handleCancel()
    }

    function handleSetFileType(fileType: string) {
        if (fileType == "") {
            setFileType(null)
        } else {
            setFileType(fileType)
        }
    }

    function handleSetTags(tags: string[]) {
        setTags(tags)
    }

    return (
        <Modal
            title={props.title}
            open={props.open}
            fullWidth={true}
            actions={
                <Box>
                    <Button
                        color="secondary"
                        onClick={handleCancel}
                    >
                        {t('common.close')}
                    </Button>
                    <Button color="secondary" onClick={() => handleDone()}>
                        {t('common.submit')}
                    </Button>
                </Box>
            }
        >
            <Box className={styles.dropContainer}>

                <FileDrop
                    message={props.message}
                    onFilesAdded={(file: File[]) => handleDrop(file)}
                    file={file}
                    multiple={props.multiple}
                />
                <Box className={styles.dropdown}>
                    {
                        props.enforceTypes != null ?
                            <DropdownSelect
                                label="Type"
                                handleChange={handleSetFileType}
                                data={props.enforceTypes}
                                value={fileType}
                                valueName={"fileType"}
                                error={errorMessage != null ? errorMessage : null}
                            >
                                {errorMessage != null ? <FormHelperText>{errorMessage}</FormHelperText> : null}
                            </DropdownSelect> :
                            errorMessage != null ? <FormHelperText>{errorMessage}</FormHelperText> : null
                    }
                </Box>
                <Box className={styles.dropdown}>
                    {
                        !!props.hasTags ?
                            <Textbox
                                label="Tags"
                                handleChange={handleSetTags}
                                options={pastTags}
                                value={tags}
                            /> :
                            errorMessage != null ? <FormHelperText>{errorMessage}</FormHelperText> : null
                    }
                </Box>
            </Box>
        </Modal >
    )
}

FileDropModal.propTypes = {
    fileType: PropTypes.string,
    handleDone: PropTypes.func.isRequired
}

export default FileDropModal



